const createRecentlyViewed = () =>
  new Vue({
    data: () => {
      return {
        listData: [],
        sectionId: "",
        nodata: false,
        page: 1,
        size: 100,
        total: 0,
        searchVal: "",
        currencyCode: "USD",
        currencySymbol: "$",
        isLoading: false,
        productAdapter: new ProductApi(),
        // deleteUrl: "web.ProductService/DeleteBrowsingHistory",
      };
    },
    created() {
      const jsonString = theme.getCookies("userSelected");
      const userSelected = theme.inspectJson(jsonString);
      this.currencyCode = userSelected?.currency_code || "USD";
      this.currencySymbol = decodeURIComponent(
        userSelected?.currency_symbol ?? "US$"
      );
      this.init();
    },
    methods: {
      init() {
        this.listData = [];
        this.nodata = false;
        this.getList();
      },
      async getList() {
        const params = {
          pageSize: {
            page: this.page,
            size: this.size,
          },
        };
        this.isLoading = true;
        const response = await this.productAdapter.getHistory(params);
        if (response) {
          this.listData = response.items;
          this.total = response?.total;
          this.nodata = this.total == 0 ? true : false;
        }
        this.isLoading = false;
      },
      formatPrice(item) {
        if (item.maxPrice == item.minPrice) {
          return `${theme.formatPrice(
            theme.convertCurrency(item.maxPrice, "usdToSet")
          )}`;
        } else {
          return `${theme.formatPrice(
            theme.convertCurrency(item.minPrice, "usdToSet")
          )} - ${theme.formatPrice(
            theme.convertCurrency(item.maxPrice, "usdToSet"),
            false
          )}`;
        }
      },
      // 获取不同类型的id
      getIdStr(name, id) {
        return `${name}-${this.sectionId}-${id}`;
      },
      // 返回产品url
      productUrl(item) {
        return `/products/${item?.handle}`;
      },
      async deleteItem(handle) {
        const params = {
          pageSize: {
            page: 1,
            size: this.size,
          },
        };
        this.isLoading = true;
        const response = await this.productAdapter.delHistory([handle]);
        if (response) {
          const listResponse = await this.productAdapter.getHistory(params);
          if (listResponse) {
            this.listData = listResponse.items;
            this.total = listResponse?.total;
            this.nodata = this.total == 0 ? true : false;
          }
        }
        this.isLoading = false;
      },
    },
    template: `
      <div class="content-list right-content hidden" id="recently-viewed">
        <div class="flex justify-space-between font-size-20 font-bold">
          <div>Recently Viewed</div>
        </div>
        <div class="grid grid--5-col-desktop product-list" v-if="!nodata">
          <div class="grid-item" v-for="item in listData">
            <div class="relative">
              <a class="basic-image" :href="productUrl(item)" target="_blank">
                <img class="" :src="item.featuredImage + '?width=370'">
              </a>
              <div class="float-remove-item" @click.stop="deleteItem(item.handle)">
                Remove item
              </div>
            </div>
            <div class="relative">
              <wb-card-variant>
                <div class="wbproductdes">
                  <product-info :id="getIdStr('ProductInfo',item.id)" :data-section-input="sectionId" :data-section="sectionId" data-layout="card" :data-url="productUrl(item)">
                    <div class="card__information">
                      <h2 class="cardhide_toggle card__heading overflow_text h5" :id="getIdStr('title',item.id)">
                        <a :href="productUrl(item)" :id="getIdStr('CardLink',item.id)" class="full-unstyled-link" target="_blank">
                          {{ item.title}}
                        </a>
                      </h2>
                      <div class="card-information">
                        <div class="no-js-hidden wbhprice" :id="getIdStr('price',item.id)" role="status">
                          <div class="card_product_Price">
                            <span class="card_sale_price price notranslate">
                              {{ formatPrice(item) }}
                            </span>
                          </div>
                        </div>
                      
                        <div class="flex wuyuwuwwd">
                          <div class="flex align-center">
                            <div class="wb_select_btnaa1">
                              <modal-opener data-modal="#QuickAdd" class="relative">
                                <button :id="getIdStr('quick-add',item.id)" type="submit" name="add" class="wb_select_btn1 link underlined-link quick-add__submit button--full-width" aria-haspopup="dialog"  :data-product-url="productUrl(item)" :data-product-id="item.id" data-gpo-collection-item-handle="fashion-national-flag-stainless-steel-necklace-dripping-oil-stainless-steel-necklaces-2">
                                  <span class="hidden">
                                    <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-plus" fill="none" viewBox="0 0 10 10">
                                      <path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor"></path>
                                    </svg>
                                    Select options
                                  </span>
                                  <div>
                                    <img class="cart-img heratPop" src="https://cdn.shopify.com/s/files/1/0574/9807/5287/files/new-shopping-cart-af002be6.png?v=1716603513">
                                  </div>
                                  <div class="loading-overlay__spinner hidden">
                                    <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                                      <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                                    </svg>
                                  </div>
                                </button>
                                <span class="add-cart-count" :class="item.cartCount>0 ? '' : 'hidden'" :data-id="item.id">{{ item.cartCount > 99 ? '99+' : item.cartCount }}</span>
                              </modal-opener>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </product-info>
                </div>
              </wb-card-variant>
            </div>
          </div>
        </div>
        <div class="mask" v-if="isLoading"></div>
        <div class="flex justify-content-center align-items-center no-data product-list" v-if="nodata">
          <div>
            <img src="https://assets.gooddiy.com/image/no-data.png">
          </div>
        </div>
      </div>`,
  });

let recentlyViewed = null;
